import { createContext, useContext, useReducer } from 'react'
import { organizationConst } from '../utils/action.constant'
import { parseJSONString } from '../utils/common.util'
import { ORG_DEFAULT_COLOR } from './../const/organization'

const OrganizationContext = createContext()
export const useOrganizationContext = () => useContext(OrganizationContext)

const initialState = {
  orgsColor: {},
}

const organizationReducer = (state, action) => {
  switch (action.type) {
    case organizationConst.SET_ALL_ORGS_COLOR:
      const orgsColorObj = {}
      let color
      action.payload?.forEach((org, index) => {
        try {
          const colorPalette = parseJSONString(
            org?.organization_color_palette_data
          )
          if (colorPalette) color = colorPalette.color1
          else color = ORG_DEFAULT_COLOR
        } catch (e) {
          color = ORG_DEFAULT_COLOR
        }
        orgsColorObj[org.organization_id] = color
      })

      return {
        ...state,
        orgsColor: orgsColorObj,
      }
    default:
      return state
  }
}

export const OrganizationContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(organizationReducer, initialState)

  return (
    <OrganizationContext.Provider value={{ state, dispatch }}>
      {children}
    </OrganizationContext.Provider>
  )
}
